import classNames from "classnames";
import React from "react";
import {
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Label,
} from "reactstrap";

const CustomInput = (props) => {
  const [state, setState] = React.useState({});

  const {
    icon,
    name,
    onChange,
    onBlur,
    touched,
    type,
    errors,
    placeholder,
    value,
    label,
    ...rest
  } = props;
  return (
    <div className="custom_input">
      <InputGroup
        className={classNames({
          "input-group-focus": state.name,
        })}
      >
        {label && (
          <Label
            className="d-block w-100 text-left text-capitalize"
            htmlFor={name}
          >
            {label}
          </Label>
        )}
        {icon && (
          <InputGroupAddon addonType="prepend">
            <InputGroupText>{icon}</InputGroupText>
          </InputGroupAddon>
        )}
        <Input
          id={name}
          name={name}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          onBlur={(e) => {
            onBlur(e);
            setState({ ...state, name: false });
          }}
          value={value?.[name]}
          onFocus={(e) => setState({ ...state, name: true })}
          {...rest}
        />
      </InputGroup>
      {touched[name] && errors[name] && (
        <span className="error text-danger">{errors[name]}</span>
      )}
    </div>
  );
};

export default CustomInput;
